import { Flex } from 'common/flex';
import { PADDING } from 'constants/sizes';

interface SectionProps {
  gap?: string;
  title?: string;
  maxWidth: string;
  children: React.ReactNode;
}

export const Section = ({
  title,
  maxWidth,
  children,
  gap = PADDING.default,
}: SectionProps) => {
  return (
    <Flex gap={gap} width="100%" maxWidth={maxWidth} flexDirection="column">
      {title && <h1>{title}</h1>}
      {children}
    </Flex>
  );
};
